angular.module('igs.common.inputs', []).directive('igsCommonInput',[
    function () {
        'use strict';
        return{
            restrict: 'E',
            transclude: true,
            template: require('./IgsInput.html'),
            link: function($scope, element, attrs, ctrl, transclude){
                transclude($scope, function(clone) {
                    element.find('ng-transclude').replaceWith(clone);
                });

                attrs.$observe('label', function() {
                    element.find('label').html(attrs.label);
                });
            }
        };
    }
]);

angular.module('igs.common.inputs').directive('igsCommonInputInline',[
    function () {
        'use strict';
        return{
            restrict: 'E',
            transclude: true,
            templateUrl: '../common/modules/IgsInput/IgsInputInline.html',
            link: function($scope, element, attrs, ctrl, transclude){
                transclude($scope, function(clone) {
                    element.find('ng-transclude').replaceWith(clone);
                });

                attrs.$observe('label', function() {
                    element.find('label').html(attrs.label);
                });
            }
        };
    }
]);

angular.module('igs.common.inputs').directive('igsCommonInputCheckbox',[
    function () {
        'use strict';
        return{
            restrict: 'E',
            transclude: true,
            templateUrl: '../common/modules/IgsInput/IgsInputCheckbox.html',
            link: function($scope, element, attrs, ctrl, transclude){
                transclude($scope, function(clone) {
                    element.find('ng-transclude').replaceWith(clone);
                });

                attrs.$observe('label', function() {
                    element.find('label').html(attrs.label);
                });
            }
        };
    }
]);
